import { render } from "./Add.vue?vue&type=template&id=17d5f083&ts=true"
import script from "./Add.vue?vue&type=script&lang=ts"
export * from "./Add.vue?vue&type=script&lang=ts"

import exportComponent from "/home/kuradmin/dev-frontend-siputra/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__